import { useMemo } from "react";
import { bool } from "prop-types";
import { observer } from "mobx-react";
import { MinAvgMaxKeys } from "@repo/utils";
import { useEstimateStructure } from "@tools";
import { BufferTooltipContent } from "./components";

export const TotalWorkTypeBufferTooltip = observer(({
  isPrice,
  isMax,
}) => {
  const structure = useEstimateStructure();
  const { maxValuesAsBuffer } = structure.settings;
  
  const displayTwoValues = structure.displayTotalTwoValues;
  
  const valueKey = useMemo(() => {
    if(maxValuesAsBuffer)
      return MinAvgMaxKeys.AVG;
    if(isMax)
      return MinAvgMaxKeys.MAX;
    
    return displayTwoValues ? MinAvgMaxKeys.MIN : MinAvgMaxKeys.AVG;
  }, [isMax, displayTwoValues, maxValuesAsBuffer])
  
  const cleanValue = isPrice
    ? structure.totalUnbufferedCost[valueKey]
    : structure.totalUnbufferedHours[valueKey];
  
  const bufferedValues = structure.getTotalBufferValues(valueKey, isPrice);
  
  return <BufferTooltipContent
    isPrice={isPrice}
    cleanValue={cleanValue}
    bufferedValues={bufferedValues}
    splitBufferTypes
  />
});

TotalWorkTypeBufferTooltip.propTypes = {
  isMax: bool,
  isPrice: bool,
}